import { useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { useTotalCart } from '../../../../hooks/useTotalCart';
import { Order } from "../../../../interfaces/domain/menu";
import { useItemsStore, useUIStore } from '../../../../store';
import styles from './TotalCart.module.scss';
import { formatPrice } from '../../../../utils/formatersPrecio';

interface TotalCartProps {
  orders: Order[];
  total: number;
  desktop?: boolean;
}

export const TotalCart = ({ orders, total, desktop }: TotalCartProps) => {
  const { totalItems, handleSendWhatsApp, openCart } = useTotalCart(orders, total);
  const setSection = useUIStore((s) => s.setSection);
  const section = useUIStore((s) => s.section);
  const menuUpdatedWarning = useItemsStore((s) => s.menuUpdatedWarning);

  useEffect(() => {
    if (totalItems === 0) {
      setSection("home");
    }
  }, [totalItems, setSection]);

  // En desktop siempre usa containerDesktop
  // En mobile usa container o containerWhithOutOrder según items
  const containerClass = desktop
    ? styles.containerDesktop
    : totalItems > 0
      ? styles.container
      : styles.containerWhithOutOrder;

  return (
    <div className={containerClass}>
      {totalItems > 0 ? (
        <div className={styles.totalQuantityTotal}>
          <div className={styles.titleQuantity}>
            <p className={styles.title}>Total</p>
            <span className={styles.itemCount}> ({totalItems} unidades)</span>
          </div>
          <h6 className={styles.total}>{formatPrice(total)}</h6>
        </div>
      ) : (
        <div className={styles.titleQuantityTotal}>
          <div className={styles.titleQuantity}>
            <p className={styles.title}>Total</p>
            <span className={styles.itemCount}> ({totalItems} unidades)</span>
          </div>
        </div>
      )}

      {desktop && menuUpdatedWarning && totalItems > 0 && (
        <p className={styles.menuUpdatedWarning}>
          Los precios de tu pedido cambiaron. Revisá antes de enviar.
        </p>
      )}

      <div className={totalItems > 0 ? styles.containeriewAndSend : styles.containeriewAndSendWhitOutQuantity}>
        {totalItems > 0 ? (
          <>
            {section === "home" && (
              <a onClick={openCart} className={styles.seeMore}>Ver Pedido</a>
            )}
            <button className={styles.buttonSend} onClick={handleSendWhatsApp}>
              Enviar pedido <FaWhatsapp size={30} />
            </button>
          </>
        ) : (
          <button className={styles.buttonSendDisabled} disabled>
            Enviar pedido <FaWhatsapp size={30} />
          </button>
        )}
      </div>
    </div>
  );
};
